document.addEventListener('DOMContentLoaded', function () {
  function closeAll() {
    document.querySelectorAll('.specs-table__info-btn.is-open').forEach(function (btn) {
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  // Mobile tap: toggle is-open on the button (CSS handles the rest)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.specs-table__info-btn');

    if (btn) {
      e.stopPropagation();
      const isOpen = btn.classList.contains('is-open');
      closeAll();
      if (!isOpen) {
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // Tap outside: close all
    closeAll();
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const openBtn = document.querySelector('.specs-table__info-btn.is-open');
      if (openBtn) {
        closeAll();
        openBtn.focus();
      }
    }
  });
});
